// <copyright file="app.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 10/09/2025 by Naziya Firdos
// </copyright>

import { Component, HostListener, inject, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { CommonAPiService } from "./shared/services/common-service";
import { SessionTimeoutService } from "./shared/services/session-timeout-service";
import { AuthTokenStore } from "./shared/stores/auth-token-store";
import { SessionLogoutService } from "./shared/services/session-logout-service";
import { HttpErrorResponse } from "@angular/common/http";
import { ApiResponseHandlerService } from "./shared/services/api-response-handler-service";

@Component({
  selector: "app-root",
  imports: [RouterOutlet],
  templateUrl: "./app.html",
  styleUrl: "./app.scss"
})
export class App implements OnInit {
  private commonApiService = inject(CommonAPiService);
  sessionService = inject(SessionTimeoutService);
  private authTokenStore = inject(AuthTokenStore);
  private sessionLogoutService = inject(SessionLogoutService);
  private readonly apiResponseHandlerService = inject(ApiResponseHandlerService);
  ngOnInit(): void {
    const token = this.authTokenStore.getAccessToken();
    if (token) {
      this.callCommonAPI();
    }
  }
  callCommonAPI() {
    this.commonApiService.fetchProfile().subscribe({
      next: (response) => {
        if (response) {
          this.sessionService.startWatching();
        }
      },
      error: (error: HttpErrorResponse) => {
        this.apiResponseHandlerService.handleError(error);
      }
    });
    this.commonApiService.getRegionAPiResponse().subscribe({
      next: () => {
        console.info("Region API success");
      },
      error: (error: HttpErrorResponse) => {
        this.apiResponseHandlerService.handleError(error);
      }
    });
    this.commonApiService.fetchRoleList().subscribe({
      next: () => {
        console.info("Role API success");
      },
      error: (error: HttpErrorResponse) => {
        this.apiResponseHandlerService.handleError(error);
      }
    });

    this.commonApiService.fetchWebAppVersion().subscribe({
      next: (response) => {
      },
      error: (error: HttpErrorResponse) => {
        this.apiResponseHandlerService.handleError(error);
      }
    });
  }

  @HostListener("window:beforeunload")
  onBeforeUnload() {
    const accessToken = this.authTokenStore.getAccessToken();
    if (accessToken) {
      this.sessionLogoutService.terminateSession();
    }
  }
}
